/** Textos do módulo Documentos e assinatura (pacote 2). Sem travessão e sem emoji; o es usa "tú". */
const pt = {
  nome: 'Documentos e assinatura',
  buscaGlobal: { arquivos: 'Arquivos' },
  abas: { arquivos: 'Arquivos', contratos: 'Contratos', assinaturas: 'Assinaturas eletrônicas' },
  indicadores: { assinaturas_em_andamento: 'Assinaturas em andamento' },
  acoes: {
    adicionarEmail: 'Adicionar por e-mail',
    atualizar: 'Atualizar do provedor',
    baixarAssinado: 'Baixar o PDF assinado',
    provedorPadrao: 'Provedor padrão',
    voltarPadrao: 'Voltar ao padrão do workspace',
    anexar: 'Anexar documento',
    escolherArquivo: 'Escolher arquivo',
    trocarArquivo: 'Trocar arquivo',
    novaVersao: 'Nova versão',
    baixar: 'Baixar',
    baixarVersao: 'Baixar a versão {{versao}}',
    editar: 'Editar',
    excluir: 'Excluir',
    salvar: 'Salvar',
    gerarContrato: 'Gerar contrato',
    novoModelo: 'Novo modelo',
    enviarAssinatura: 'Enviar para assinatura',
    salvarRascunho: 'Salvar rascunho',
    salvarEnviar: 'Salvar e enviar',
    enviar: 'Enviar',
    assinar: 'Assinar',
    recusar: 'Recusar',
    cancelar: 'Cancelar envio',
    comprovante: 'Baixar comprovante',
    adicionarEquipe: 'Adicionar da equipe',
    adicionarCliente: 'Adicionar do cliente',
    remover: 'Remover {{nome}}',
    abrirDocumento: 'Abrir o documento',
    abrirAssinatura: 'Abrir a assinatura',
  },
  campos: {
    assinante: 'Quem assina pela empresa',
    provedor: 'Provedor da assinatura',
    provedorAjuda: 'Começa no padrão da empresa; dá para trocar neste envio.',
    email: 'E-mail',
    nomeCompleto: 'Nome completo',
    empresa: 'Empresa',
    nome: 'Nome',
    nomeAjuda: 'Vazio: o nome do arquivo.',
    arquivo: 'Arquivo',
    tipo: 'Tipo',
    ligadoA: 'Ligado a',
    registro: 'Registro',
    tags: 'Etiquetas',
    versao: 'Versão',
    versoes: 'Versões',
    tamanho: 'Tamanho',
    hash: 'SHA-256',
    criadoPor: 'Criado por',
    atualizado: 'Atualizado',
    assinatura: 'Assinatura',
    assinaturas: 'Assinaturas',
    modelo: 'Modelo',
    parceiro: 'Cliente ou fornecedor',
    descricao: 'Descrição',
    corpo: 'Texto do contrato',
    corpoAjuda: 'Use as variáveis entre chaves duplas; o sistema preenche ao gerar.',
    variaveis: 'Variáveis disponíveis',
    ativo: 'Ativo',
    contratos: 'Contratos gerados',
    documento: 'Documento',
    signatarios: 'Quem assina',
    mensagem: 'Recado para quem assina',
    prazo: 'Prazo para assinar',
    prazoAjuda: 'Vazio: sem prazo.',
    estado: 'Situação',
    enviada: 'Enviada em',
    concluida: 'Concluída em',
    motivo: 'Motivo',
    trilha: 'Trilha da assinatura',
    quando: 'Quando',
    ip: 'IP',
    navegador: 'Navegador',
    acessoCliente: 'Pessoa do cliente',
    pessoaEquipe: 'Pessoa da equipe',
  },
  tipo: { arquivo: 'Arquivo', contrato: 'Contrato' },
  registros: { nenhum: 'Nenhum (avulso)', 'cadastros.parceiro': 'Cliente ou fornecedor', 'cadastros.projeto': 'Projeto', 'pessoas.funcionario': 'Funcionário', 'assinaturas.contrato': 'Contrato (Assinaturas)', outro: 'Registro de outro módulo' },
  estado: { rascunho: 'Rascunho', enviado: 'Aguardando assinatura', assinado: 'Assinado', recusado: 'Recusado', cancelado: 'Cancelado', expirado: 'Prazo vencido', todos: 'Todas' },
  signatario: { pendente: 'Pendente', assinado: 'Assinou', recusado: 'Recusou', interno: 'Equipe', cliente: 'Cliente, pelo Portal', externo: 'Pelo e-mail do provedor' },
  evento: {
    criada: 'Envio preparado',
    enviada: 'Enviado para assinatura',
    visualizada: 'Documento aberto pelo cliente',
    assinada: 'Assinado',
    recusada: 'Recusado',
    cancelada: 'Envio cancelado',
    concluida: 'Assinatura concluída',
    expirada: 'Prazo para assinar vencido',
  },
  ator: { usuario: 'Equipe', cliente: 'Cliente', sistema: 'Sistema', provedor: 'Provedor' },
  provedor: { nativa: 'MalgoOS (nativa)', clicksign: 'Clicksign', documenso: 'Documenso', naoConectado: '{{nome}} (não conectado)' },
  filtro: { todas: 'Todas', minhas: 'Esperando a minha assinatura' },
  docx: {
    novo: 'Importar modelo do Word',
    ajuda: 'O arquivo do Word (.docx) com campos de formulário. O sistema lê cada campo e sugere o dado que vai nele; confira o mapa depois de salvar.',
    arquivo: 'Arquivo do Word (.docx)',
    trocarArquivo: 'Trocar o arquivo (hoje na versão {{versao}})',
    importado: 'Modelo importado: confira o dado de cada campo.',
    arquivoTrocado: 'Arquivo trocado: confira o mapa da nova versão.',
    tipo: 'Tipo do documento',
    tipos: { contrato: 'Contrato', aditivo: 'Aditivo', termo: 'Termo' },
    evento: 'Usado quando',
    eventos: {
      migracao_plano: 'Troca de plano',
      suspensao: 'Suspensão',
      reativacao: 'Reativação',
      troca_regime: 'Troca de regime tributário',
      rescisao: 'Rescisão sem débitos',
      rescisao_inadimplencia: 'Rescisão por inadimplência',
      cessao: 'Cessão entre empresas do grupo',
    },
    nenhum: 'Nenhum',
    empresa: 'Empresa do grupo',
    empresaAjuda: 'O modelo é sugerido para os contratos desta empresa.',
    todas: 'Todas',
    regime: 'Regime tributário do cliente',
    soAntigos: 'Só contratos antigos',
    soAntigosAjuda: 'O aditivo ou termo só aparece para contrato sem contrato gerado no MalgoOS (os aditivos "contratos antigos").',
    todos: 'Todos',
    regimes: { simples: 'Simples Nacional', mei: 'MEI', presumido: 'Lucro Presumido', real: 'Lucro Real' },
    servico: 'Serviço do catálogo',
    servicoAjuda: 'Vazio: serve a qualquer serviço.',
    mapa: 'Dado de cada campo',
    versao: 'Versão {{versao}}',
    mapaAjuda: 'Cada campo do arquivo, na ordem, com o texto ao redor. Os marcados "no envio" a pessoa preenche ao gerar o documento.',
    mapaDepois: 'Salve para trocar o arquivo; o mapa da nova versão aparece em seguida.',
    dadoDoCampo: 'Dado do campo {{n}}',
    rotuloDoCampo: 'Rótulo do campo {{n}} no envio',
    obrigatorio: 'Obrigatório',
    noEnvio: 'no envio',
    formato: 'Formato',
    formatos: { texto: 'Texto', docx: 'Word, versão {{versao}}' },
  },
  vista: { contratos: 'Contratos gerados', modelos: 'Modelos' },
  vazio: {
    arquivos: 'Nenhum documento por aqui.',
    contratos: 'Nenhum contrato gerado ainda.',
    modelos: 'Nenhum modelo de contrato. Crie um com as variáveis do cadastro.',
    assinaturas: 'Nenhum envio para assinatura.',
    minhas: 'Nenhum documento esperando a sua assinatura.',
    signatarios: 'Adicione ao menos uma pessoa para assinar.',
    acessos: 'Este cliente não tem ninguém com acesso ativo ao Portal do cliente.',
    semPortal: 'O Portal do cliente não está ligado neste workspace: só a equipe pode assinar.',
  },
  envioContrato: {
    sugerido: 'Quem assina já vem do contrato: o cliente, o garantidor (quando o modelo pede) e quem assina pela empresa. Confira e troque se precisar.',
    provedorDocumento: 'O provedor é o que o contrato cita ({{provedor}}).',
    papel: { contratante: 'Contratante', garantidor: 'Garantidor', contratada: 'Pela empresa' },
    avisos: {
      sem_assinante: 'A empresa não tem quem assina por ela: inclua a pessoa da equipe aqui e escolha-a em Provedor padrão.',
      contratante_sem_email: 'O cliente não tem e-mail no cadastro (nem representante com e-mail): inclua quem assina pelo cliente.',
      contratante_sem_portal: 'Ninguém do cliente tem acesso ativo ao Portal do cliente: inclua quem assina pelo cliente.',
      garantidor_nao_encontrado: 'O garantidor do contrato não está entre os sócios do cliente: inclua-o à mão.',
      garantidor_sem_email: 'O garantidor não tem e-mail no cadastro: inclua-o à mão.',
      garantidor_sem_portal: 'O garantidor não tem acesso ao Portal do cliente: inclua-o à mão ou envie por um provedor.',
    },
  },
  ajuda: {
    assinante: 'Sugerido no envio do contrato gerado de modelo; dá para trocar em cada envio. Vale para o grupo: só quem vê todas as empresas muda.',
    assinaturaProvedor: 'Cada pessoa recebe o pedido de {{provedor}} por e-mail e assina lá. Quando todos assinarem, o PDF assinado volta para o documento.',
    enviando: 'Enviando para {{provedor}}: o pedido sai em instantes.',
    provedorErro: 'Problema com o provedor: {{erro}}',
    provedorPadrao: 'O provedor padrão vale para os novos envios; quem envia pode trocar em cada um. A empresa sem provedor próprio segue o padrão do workspace.',
    padraoWorkspace: 'Padrão do workspace',
    proprio: 'Próprio da empresa',
    herdado: 'Segue o padrão do workspace',
    anexar: 'O arquivo fica guardado com o histórico de versões. Ligado a um registro, só vê quem vê o registro.',
    versao: 'A versão nova não apaga a anterior: o histórico guarda todas, com o hash de cada arquivo.',
    assinatura: 'Quem é da equipe assina aqui, na tela; a pessoa do cliente assina pelo Portal do cliente, com um código enviado ao e-mail dela.',
    assinar: 'Ao assinar, ficam registrados a data e a hora, o seu IP, o navegador e o hash do arquivo desta versão.',
    hash: 'O hash SHA-256 identifica o arquivo: qualquer mudança no arquivo muda o hash.',
    trilha: 'A trilha não muda depois de gravada: cada linha guarda o hash da anterior.',
  },
  confirmar: {
    excluir: 'Excluir o documento?',
    excluirTexto: 'O documento sai da lista. Documento assinado ou em assinatura não se exclui.',
    excluirModelo: 'Excluir o modelo?',
    excluirModeloTexto: 'Os contratos já gerados com ele continuam como estão.',
    excluirAssinatura: 'Excluir o rascunho?',
    excluirAssinaturaTexto: 'O envio em rascunho sai da lista.',
    assinar: 'Assinar o documento?',
  },
  recusar: { titulo: 'Recusar a assinatura', ajuda: 'Diga o motivo: quem enviou fica sabendo.' },
  cancelar: { titulo: 'Cancelar o envio', ajuda: 'Diga o motivo: quem ainda não assinou não assina mais.' },
  versaoN: 'v{{versao}}',
  semRegistro: 'Avulso',
  semAcesso: 'Registro sem acesso',
  enviadoSucesso: 'Enviado para assinatura',
  assinadoSucesso: 'Documento assinado',
  arquivoObrigatorio: 'Escolha o arquivo do documento',
};

const en: typeof pt = {
  nome: 'Documents and signature',
  buscaGlobal: { arquivos: 'Files' },
  abas: { arquivos: 'Files', contratos: 'Contracts', assinaturas: 'E-signatures' },
  indicadores: { assinaturas_em_andamento: 'Signatures in progress' },
  acoes: {
    adicionarEmail: 'Add by email',
    atualizar: 'Update from provider',
    baixarAssinado: 'Download the signed PDF',
    provedorPadrao: 'Default provider',
    voltarPadrao: 'Back to the workspace default',
    anexar: 'Attach document',
    escolherArquivo: 'Choose file',
    trocarArquivo: 'Change file',
    novaVersao: 'New version',
    baixar: 'Download',
    baixarVersao: 'Download version {{versao}}',
    editar: 'Edit',
    excluir: 'Delete',
    salvar: 'Save',
    gerarContrato: 'Generate contract',
    novoModelo: 'New template',
    enviarAssinatura: 'Send for signature',
    salvarRascunho: 'Save draft',
    salvarEnviar: 'Save and send',
    enviar: 'Send',
    assinar: 'Sign',
    recusar: 'Decline',
    cancelar: 'Cancel sending',
    comprovante: 'Download certificate',
    adicionarEquipe: 'Add from the team',
    adicionarCliente: 'Add from the client',
    remover: 'Remove {{nome}}',
    abrirDocumento: 'Open the document',
    abrirAssinatura: 'Open the signature',
  },
  campos: {
    assinante: 'Who signs for the company',
    provedor: 'Signature provider',
    provedorAjuda: 'Starts with the company default; you can change it for this sending.',
    email: 'Email',
    nomeCompleto: 'Full name',
    empresa: 'Company',
    nome: 'Name',
    nomeAjuda: 'Empty: the file name.',
    arquivo: 'File',
    tipo: 'Type',
    ligadoA: 'Linked to',
    registro: 'Record',
    tags: 'Tags',
    versao: 'Version',
    versoes: 'Versions',
    tamanho: 'Size',
    hash: 'SHA-256',
    criadoPor: 'Created by',
    atualizado: 'Updated',
    assinatura: 'Signature',
    assinaturas: 'Signatures',
    modelo: 'Template',
    parceiro: 'Customer or supplier',
    descricao: 'Description',
    corpo: 'Contract text',
    corpoAjuda: 'Use the variables between double braces; the system fills them in when generating.',
    variaveis: 'Available variables',
    ativo: 'Active',
    contratos: 'Contracts generated',
    documento: 'Document',
    signatarios: 'Who signs',
    mensagem: 'Note to the signers',
    prazo: 'Deadline to sign',
    prazoAjuda: 'Empty: no deadline.',
    estado: 'Status',
    enviada: 'Sent on',
    concluida: 'Completed on',
    motivo: 'Reason',
    trilha: 'Signature trail',
    quando: 'When',
    ip: 'IP',
    navegador: 'Browser',
    acessoCliente: 'Client person',
    pessoaEquipe: 'Team member',
  },
  tipo: { arquivo: 'File', contrato: 'Contract' },
  registros: { nenhum: 'None (standalone)', 'cadastros.parceiro': 'Customer or supplier', 'cadastros.projeto': 'Project', 'pessoas.funcionario': 'Employee', 'assinaturas.contrato': 'Contract (Subscriptions)', outro: 'Record from another module' },
  estado: { rascunho: 'Draft', enviado: 'Waiting for signature', assinado: 'Signed', recusado: 'Declined', cancelado: 'Canceled', expirado: 'Deadline passed', todos: 'All' },
  signatario: { pendente: 'Pending', assinado: 'Signed', recusado: 'Declined', interno: 'Team', cliente: 'Client, in the Portal', externo: 'By the provider email' },
  evento: {
    criada: 'Sending prepared',
    enviada: 'Sent for signature',
    visualizada: 'Document opened by the client',
    assinada: 'Signed',
    recusada: 'Declined',
    cancelada: 'Sending canceled',
    concluida: 'Signature completed',
    expirada: 'Signing deadline passed',
  },
  ator: { usuario: 'Team', cliente: 'Client', sistema: 'System', provedor: 'Provider' },
  provedor: { nativa: 'MalgoOS (built-in)', clicksign: 'Clicksign', documenso: 'Documenso', naoConectado: '{{nome}} (not connected)' },
  filtro: { todas: 'All', minhas: 'Waiting for my signature' },
  docx: {
    novo: 'Import Word template',
    ajuda: 'The Word file (.docx) with form fields. The system reads each field and suggests the data that goes in it; check the map after saving.',
    arquivo: 'Word file (.docx)',
    trocarArquivo: 'Replace the file (now at version {{versao}})',
    importado: 'Template imported: check the data of each field.',
    arquivoTrocado: 'File replaced: check the map of the new version.',
    tipo: 'Document type',
    tipos: { contrato: 'Contract', aditivo: 'Amendment', termo: 'Term' },
    evento: 'Used when',
    eventos: {
      migracao_plano: 'Plan change',
      suspensao: 'Suspension',
      reativacao: 'Reactivation',
      troca_regime: 'Tax regime change',
      rescisao: 'Termination without debts',
      rescisao_inadimplencia: 'Termination for non-payment',
      cessao: 'Assignment between group companies',
    },
    nenhum: 'None',
    empresa: 'Group company',
    empresaAjuda: 'The template is suggested for this company’s contracts.',
    todas: 'All',
    regime: 'Customer tax regime',
    soAntigos: 'Old contracts only',
    soAntigosAjuda: 'The amendment or term only shows for a contract with no contract generated in MalgoOS (the "old contracts" amendments).',
    todos: 'All',
    regimes: { simples: 'Simples Nacional', mei: 'MEI', presumido: 'Lucro Presumido', real: 'Lucro Real' },
    servico: 'Catalog service',
    servicoAjuda: 'Empty: fits any service.',
    mapa: 'Data of each field',
    versao: 'Version {{versao}}',
    mapaAjuda: 'Each field of the file, in order, with the text around it. Those marked "when sending" are filled in when generating the document.',
    mapaDepois: 'Save to replace the file; the map of the new version shows up next.',
    dadoDoCampo: 'Data of field {{n}}',
    rotuloDoCampo: 'Label of field {{n}} when sending',
    obrigatorio: 'Required',
    noEnvio: 'when sending',
    formato: 'Format',
    formatos: { texto: 'Text', docx: 'Word, version {{versao}}' },
  },
  vista: { contratos: 'Contracts generated', modelos: 'Templates' },
  vazio: {
    arquivos: 'No documents here.',
    contratos: 'No contracts generated yet.',
    modelos: 'No contract templates. Create one with the record variables.',
    assinaturas: 'Nothing sent for signature.',
    minhas: 'No documents waiting for your signature.',
    signatarios: 'Add at least one person to sign.',
    acessos: 'This client has no one with active access to the Client portal.',
    semPortal: 'The Client portal is not on in this workspace: only the team can sign.',
  },
  envioContrato: {
    sugerido: 'The signers come from the contract: the client, the guarantor (when the template asks) and who signs for the company. Check and change if needed.',
    provedorDocumento: 'The provider is the one the contract mentions ({{provedor}}).',
    papel: { contratante: 'Client', garantidor: 'Guarantor', contratada: 'For the company' },
    avisos: {
      sem_assinante: 'The company has no one who signs for it: add the team member here and choose them in Default provider.',
      contratante_sem_email: 'The client has no email on file (nor a representative with email): add who signs for the client.',
      contratante_sem_portal: 'No one from the client has active access to the Client portal: add who signs for the client.',
      garantidor_nao_encontrado: 'The contract guarantor is not among the client partners: add them by hand.',
      garantidor_sem_email: 'The guarantor has no email on file: add them by hand.',
      garantidor_sem_portal: 'The guarantor has no access to the Client portal: add them by hand or send through a provider.',
    },
  },
  ajuda: {
    assinante: 'Suggested when sending a contract generated from a template; you can change it on each sending. Applies to the group: only those who see all companies can change it.',
    assinaturaProvedor: 'Each person gets the request from {{provedor}} by email and signs there. When everyone signs, the signed PDF returns to the document.',
    enviando: 'Sending to {{provedor}}: the request goes out in a moment.',
    provedorErro: 'Problem with the provider: {{erro}}',
    provedorPadrao: 'The default provider applies to new sendings; whoever sends can change it each time. A company without its own provider follows the workspace default.',
    padraoWorkspace: 'Workspace default',
    proprio: 'Company specific',
    herdado: 'Follows the workspace default',
    anexar: 'The file is kept with its version history. Linked to a record, only those who see the record see it.',
    versao: 'The new version does not delete the previous one: the history keeps all of them, with the hash of each file.',
    assinatura: 'Team members sign here, on the screen; the client person signs in the Client portal, with a code sent to their e-mail.',
    assinar: 'When you sign, the date and time, your IP, the browser and the hash of this version file are recorded.',
    hash: 'The SHA-256 hash identifies the file: any change to the file changes the hash.',
    trilha: 'The trail does not change once recorded: each line keeps the hash of the previous one.',
  },
  confirmar: {
    excluir: 'Delete the document?',
    excluirTexto: 'The document leaves the list. A signed document or one being signed cannot be deleted.',
    excluirModelo: 'Delete the template?',
    excluirModeloTexto: 'The contracts already generated with it stay as they are.',
    excluirAssinatura: 'Delete the draft?',
    excluirAssinaturaTexto: 'The draft sending leaves the list.',
    assinar: 'Sign the document?',
  },
  recusar: { titulo: 'Decline the signature', ajuda: 'Give the reason: whoever sent it will know.' },
  cancelar: { titulo: 'Cancel the sending', ajuda: 'Give the reason: whoever has not signed yet will not sign anymore.' },
  versaoN: 'v{{versao}}',
  semRegistro: 'Standalone',
  semAcesso: 'Record without access',
  enviadoSucesso: 'Sent for signature',
  assinadoSucesso: 'Document signed',
  arquivoObrigatorio: 'Choose the document file',
};

const es: typeof pt = {
  nome: 'Documentos y firma',
  buscaGlobal: { arquivos: 'Archivos' },
  abas: { arquivos: 'Archivos', contratos: 'Contratos', assinaturas: 'Firmas electrónicas' },
  indicadores: { assinaturas_em_andamento: 'Firmas en curso' },
  acoes: {
    adicionarEmail: 'Agregar por correo',
    atualizar: 'Actualizar del proveedor',
    baixarAssinado: 'Descargar el PDF firmado',
    provedorPadrao: 'Proveedor predeterminado',
    voltarPadrao: 'Volver al predeterminado del workspace',
    anexar: 'Adjuntar documento',
    escolherArquivo: 'Elegir archivo',
    trocarArquivo: 'Cambiar archivo',
    novaVersao: 'Nueva versión',
    baixar: 'Descargar',
    baixarVersao: 'Descargar la versión {{versao}}',
    editar: 'Editar',
    excluir: 'Eliminar',
    salvar: 'Guardar',
    gerarContrato: 'Generar contrato',
    novoModelo: 'Nueva plantilla',
    enviarAssinatura: 'Enviar para firma',
    salvarRascunho: 'Guardar borrador',
    salvarEnviar: 'Guardar y enviar',
    enviar: 'Enviar',
    assinar: 'Firmar',
    recusar: 'Rechazar',
    cancelar: 'Cancelar envío',
    comprovante: 'Descargar comprobante',
    adicionarEquipe: 'Agregar del equipo',
    adicionarCliente: 'Agregar del cliente',
    remover: 'Quitar a {{nome}}',
    abrirDocumento: 'Abrir el documento',
    abrirAssinatura: 'Abrir la firma',
  },
  campos: {
    assinante: 'Quién firma por la empresa',
    provedor: 'Proveedor de la firma',
    provedorAjuda: 'Empieza con el predeterminado de la empresa; puedes cambiarlo en este envío.',
    email: 'Correo',
    nomeCompleto: 'Nombre completo',
    empresa: 'Empresa',
    nome: 'Nombre',
    nomeAjuda: 'Vacío: el nombre del archivo.',
    arquivo: 'Archivo',
    tipo: 'Tipo',
    ligadoA: 'Vinculado a',
    registro: 'Registro',
    tags: 'Etiquetas',
    versao: 'Versión',
    versoes: 'Versiones',
    tamanho: 'Tamaño',
    hash: 'SHA-256',
    criadoPor: 'Creado por',
    atualizado: 'Actualizado',
    assinatura: 'Firma',
    assinaturas: 'Firmas',
    modelo: 'Plantilla',
    parceiro: 'Cliente o proveedor',
    descricao: 'Descripción',
    corpo: 'Texto del contrato',
    corpoAjuda: 'Usa las variables entre llaves dobles; el sistema las completa al generar.',
    variaveis: 'Variables disponibles',
    ativo: 'Activo',
    contratos: 'Contratos generados',
    documento: 'Documento',
    signatarios: 'Quién firma',
    mensagem: 'Nota para quien firma',
    prazo: 'Plazo para firmar',
    prazoAjuda: 'Vacío: sin plazo.',
    estado: 'Situación',
    enviada: 'Enviada el',
    concluida: 'Concluida el',
    motivo: 'Motivo',
    trilha: 'Rastro de la firma',
    quando: 'Cuándo',
    ip: 'IP',
    navegador: 'Navegador',
    acessoCliente: 'Persona del cliente',
    pessoaEquipe: 'Persona del equipo',
  },
  tipo: { arquivo: 'Archivo', contrato: 'Contrato' },
  registros: { nenhum: 'Ninguno (suelto)', 'cadastros.parceiro': 'Cliente o proveedor', 'cadastros.projeto': 'Proyecto', 'pessoas.funcionario': 'Empleado', 'assinaturas.contrato': 'Contrato (Suscripciones)', outro: 'Registro de otro módulo' },
  estado: { rascunho: 'Borrador', enviado: 'Esperando firma', assinado: 'Firmado', recusado: 'Rechazado', cancelado: 'Cancelado', expirado: 'Plazo vencido', todos: 'Todas' },
  signatario: { pendente: 'Pendiente', assinado: 'Firmó', recusado: 'Rechazó', interno: 'Equipo', cliente: 'Cliente, por el Portal', externo: 'Por el correo del proveedor' },
  evento: {
    criada: 'Envío preparado',
    enviada: 'Enviado para firma',
    visualizada: 'Documento abierto por el cliente',
    assinada: 'Firmado',
    recusada: 'Rechazado',
    cancelada: 'Envío cancelado',
    concluida: 'Firma concluida',
    expirada: 'Plazo para firmar vencido',
  },
  ator: { usuario: 'Equipo', cliente: 'Cliente', sistema: 'Sistema', provedor: 'Proveedor' },
  provedor: { nativa: 'MalgoOS (nativa)', clicksign: 'Clicksign', documenso: 'Documenso', naoConectado: '{{nome}} (no conectado)' },
  filtro: { todas: 'Todas', minhas: 'Esperando mi firma' },
  docx: {
    novo: 'Importar plantilla de Word',
    ajuda: 'El archivo de Word (.docx) con campos de formulario. El sistema lee cada campo y sugiere el dato que va en él; revisa el mapa después de guardar.',
    arquivo: 'Archivo de Word (.docx)',
    trocarArquivo: 'Cambiar el archivo (hoy en la versión {{versao}})',
    importado: 'Plantilla importada: revisa el dato de cada campo.',
    arquivoTrocado: 'Archivo cambiado: revisa el mapa de la nueva versión.',
    tipo: 'Tipo de documento',
    tipos: { contrato: 'Contrato', aditivo: 'Adenda', termo: 'Término' },
    evento: 'Se usa cuando',
    eventos: {
      migracao_plano: 'Cambio de plan',
      suspensao: 'Suspensión',
      reativacao: 'Reactivación',
      troca_regime: 'Cambio de régimen tributario',
      rescisao: 'Rescisión sin deudas',
      rescisao_inadimplencia: 'Rescisión por impago',
      cessao: 'Cesión entre empresas del grupo',
    },
    nenhum: 'Ninguno',
    empresa: 'Empresa del grupo',
    empresaAjuda: 'La plantilla se sugiere para los contratos de esta empresa.',
    todas: 'Todas',
    regime: 'Régimen tributario del cliente',
    soAntigos: 'Solo contratos antiguos',
    soAntigosAjuda: 'La adenda o el término solo aparece para el contrato sin contrato generado en MalgoOS (las adendas "contratos antiguos").',
    todos: 'Todos',
    regimes: { simples: 'Simples Nacional', mei: 'MEI', presumido: 'Lucro Presumido', real: 'Lucro Real' },
    servico: 'Servicio del catálogo',
    servicoAjuda: 'Vacío: sirve para cualquier servicio.',
    mapa: 'Dato de cada campo',
    versao: 'Versión {{versao}}',
    mapaAjuda: 'Cada campo del archivo, en orden, con el texto alrededor. Los marcados "en el envío" se llenan al generar el documento.',
    mapaDepois: 'Guarda para cambiar el archivo; el mapa de la nueva versión aparece enseguida.',
    dadoDoCampo: 'Dato del campo {{n}}',
    rotuloDoCampo: 'Etiqueta del campo {{n}} en el envío',
    obrigatorio: 'Obligatorio',
    noEnvio: 'en el envío',
    formato: 'Formato',
    formatos: { texto: 'Texto', docx: 'Word, versión {{versao}}' },
  },
  vista: { contratos: 'Contratos generados', modelos: 'Plantillas' },
  vazio: {
    arquivos: 'Ningún documento por aquí.',
    contratos: 'Ningún contrato generado todavía.',
    modelos: 'Ninguna plantilla de contrato. Crea una con las variables del registro.',
    assinaturas: 'Ningún envío para firma.',
    minhas: 'Ningún documento esperando tu firma.',
    signatarios: 'Agrega al menos una persona para firmar.',
    acessos: 'Este cliente no tiene a nadie con acceso activo al Portal del cliente.',
    semPortal: 'El Portal del cliente no está activado en este workspace: solo el equipo puede firmar.',
  },
  envioContrato: {
    sugerido: 'Quién firma ya viene del contrato: el cliente, el garante (cuando la plantilla lo pide) y quién firma por la empresa. Revisa y cambia si hace falta.',
    provedorDocumento: 'El proveedor es el que cita el contrato ({{provedor}}).',
    papel: { contratante: 'Contratante', garantidor: 'Garante', contratada: 'Por la empresa' },
    avisos: {
      sem_assinante: 'La empresa no tiene quién firme por ella: incluye a la persona del equipo aquí y elígela en Proveedor predeterminado.',
      contratante_sem_email: 'El cliente no tiene correo en el registro (ni representante con correo): incluye a quién firma por el cliente.',
      contratante_sem_portal: 'Nadie del cliente tiene acceso activo al Portal del cliente: incluye a quién firma por el cliente.',
      garantidor_nao_encontrado: 'El garante del contrato no está entre los socios del cliente: inclúyelo a mano.',
      garantidor_sem_email: 'El garante no tiene correo en el registro: inclúyelo a mano.',
      garantidor_sem_portal: 'El garante no entra al Portal del cliente: inclúyelo a mano o elige un proveedor.',
    },
  },
  ajuda: {
    assinante: 'Se sugiere al enviar el contrato generado de plantilla; puedes cambiarlo en cada envío. Vale para el grupo: solo quien ve todas las empresas lo cambia.',
    assinaturaProvedor: 'Cada persona recibe la solicitud de {{provedor}} por correo y firma allí. Cuando todos firmen, el PDF firmado vuelve al documento.',
    enviando: 'Enviando a {{provedor}}: la solicitud sale en instantes.',
    provedorErro: 'Problema con el proveedor: {{erro}}',
    provedorPadrao: 'El proveedor predeterminado vale para los nuevos envíos; quien envía puede cambiarlo en cada uno. La empresa sin proveedor propio sigue el predeterminado del workspace.',
    padraoWorkspace: 'Predeterminado del workspace',
    proprio: 'Propio de la empresa',
    herdado: 'Sigue el predeterminado del workspace',
    anexar: 'El archivo queda guardado con el historial de versiones. Vinculado a un registro, solo lo ve quien ve el registro.',
    versao: 'La versión nueva no borra la anterior: el historial guarda todas, con el hash de cada archivo.',
    assinatura: 'Quien es del equipo firma aquí, en la pantalla; la persona del cliente firma por el Portal del cliente, con un código enviado a su correo.',
    assinar: 'Al firmar, quedan registrados la fecha y la hora, tu IP, el navegador y el hash del archivo de esta versión.',
    hash: 'El hash SHA-256 identifica el archivo: cualquier cambio en el archivo cambia el hash.',
    trilha: 'El rastro no cambia después de grabado: cada línea guarda el hash de la anterior.',
  },
  confirmar: {
    excluir: '¿Eliminar el documento?',
    excluirTexto: 'El documento sale de la lista. Un documento firmado o en firma no se elimina.',
    excluirModelo: '¿Eliminar la plantilla?',
    excluirModeloTexto: 'Los contratos ya generados con ella siguen como están.',
    excluirAssinatura: '¿Eliminar el borrador?',
    excluirAssinaturaTexto: 'El envío en borrador sale de la lista.',
    assinar: '¿Firmar el documento?',
  },
  recusar: { titulo: 'Rechazar la firma', ajuda: 'Di el motivo: quien lo envió lo sabrá.' },
  cancelar: { titulo: 'Cancelar el envío', ajuda: 'Di el motivo: quien todavía no firmó ya no firmará.' },
  versaoN: 'v{{versao}}',
  semRegistro: 'Suelto',
  semAcesso: 'Registro sin acceso',
  enviadoSucesso: 'Enviado para firma',
  assinadoSucesso: 'Documento firmado',
  arquivoObrigatorio: 'Elige el archivo del documento',
};

export const i18n = { pt, en, es };
